import messages from '@smartmixin/i18n/dist/translations/el.json';

export default messages;
